import React from 'react';
import AvatarComponent from 'react-user-avatar';
import PropTypes from 'prop-types';
import './style.css';
var Avatar = function Avatar(props) {
  return React.createElement(AvatarComponent, props);
};

Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * User name
   */
  name: PropTypes.string,
  /**
   * size of the avatar
   */
  size: PropTypes.string,
  /**
   * background color (forcefully set)
   */
  color: PropTypes.string,
  /**
   * range of colors
   */
  colors: PropTypes.array,
  /**
   * profile image url
   */
  src: PropTypes.string

} : {};
export default Avatar;